import { LOCATION_STORE_PARAM_NAME } from 'src/common/constants.ts';
import { compressToEncodedURIComponent } from 'lz-string';

export const updatedLocationState = <T>(searchParams: URLSearchParams, locationState: T) => {
    searchParams.set(LOCATION_STORE_PARAM_NAME, compressToEncodedURIComponent(JSON.stringify(locationState)));
    return searchParams;
};
